export enum ValidationStatus {
  NO_ERROR = "NO_ERROR",
  WARNINGS = "WARNINGS",
  ERRORS = "ERRORS",
  FATAL_ERRORS = "FATAL_ERRORS",
}
